import api from '../../plugins/api';

const getBuInfo = (carId) => {
  return api.get(`api/shop/buInfo?carId=${carId}`);
};

export default getBuInfo;
